import { z } from 'zod';

export const PROJECT_BUDGETS = [10000, 100000, 1000000, 10000000, 100000000]; // in dollar
export const DEFAULT_PROJECT_BUDGET = { min: 10000, max: 100000000 };

const validator = z
    .object({
        min: z.number().optional(),
        max: z.number().optional(),
    })
    .optional()
    .default(DEFAULT_PROJECT_BUDGET);

export const ProjectBudget = { validator };
